module.exports = __webpack_public_path__ + "img/our-la_header-image_sofi-stadium.c5d7a64e.jpg";